// Copyright (c) 2017 Deere & Company

import './index.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import {
    canEnableSubmit,
    isAnyRateLowerThanCurrentRate
} from '../services/labor-rate-change-services';
import ConfirmationModal from '../../../shared/components/confirmation-modal';
import {FormattedMessage} from 'react-intl';
import LaborRate from '@deere/cps-it.warranty-model-factory/lib/labor-rate';
import LaborRateMain from './labor-rate-main';
import {Link} from 'react-router';
import SubmitButton from './submit-button';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';

function onSubmit() {

    isAnyRateLowerThanCurrentRate(this.laborRate.rates) ?
        this.actions.updateConfirmationModalVisibility(true) :
        this.actions.postLaborRateChange(this.laborRate);

}

function handleConfirmationModalClose() {

    this.actions.updateConfirmationModalVisibility(false);

}

function onConfirm() {

    this.actions.postLaborRateChange(this.laborRate);
    this.actions.updateConfirmationModalVisibility(false);

}

class LaborRateChange extends Component {

    componentWillMount() {

        this.props.actions.readLaborRates(this.props.routeParams.account);

    }

    componentWillUnmount() {

        this.props.actions.updateIsSubmitDisabled(true);

    }

    render() {

        return (
            <section className='labor-rate-change'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <h2 className='title-row'>
                    <section className='dealer-name'>
                        {this.props.laborRate.responsibleAccount.name}
                    </section>
                    <section className='buttons'>
                        <Link
                            className='button-secondary'
                            to='/claims/labor-rates'
                        >
                            <FormattedMessage id='CANCEL'/>
                        </Link>
                        <SubmitButton
                            isSubmitDisabled={!canEnableSubmit(this.props.laborRate.rates)}
                            laborRate={this.props.laborRate}
                            onClick={this.props::onSubmit}
                        />
                    </section>
                </h2>
                <LaborRateMain
                    actions={this.props.actions}
                    laborRate={this.props.laborRate}
                    tcsm={false}
                />
                <ConfirmationModal
                    confirmMessage='LABOR_RATE_CONFIRM'
                    isOpen={this.props.isConfirmationModalVisible}
                    onClose={this.props::handleConfirmationModalClose}
                    onConfirm={this.props::onConfirm}
                    title='UPDATE_LABOR_RATES'
                />
            </section>
        );

    }

}

LaborRateChange.displayName = 'LaborRateChange';
LaborRateChange.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    isConfirmationModalVisible: PropTypes.bool.isRequired,
    laborRate: PropTypes.instanceOf(LaborRate).isRequired,
    routeParams: PropTypes.object.isRequired
};

export default LaborRateChange;



// WEBPACK FOOTER //
// ./src/claim/labor-rate-change/components/index.js